<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="1000">
      <v-card>
        <v-card-title class="d-flax px-12 pt-12">
          <v-row>
            <v-col cols="6" lg="auto" md="auto" sm="auto" class="pr-0 pl-8">
              <img
                :src="require('@/assets/icon/Telepharma/Frame 427325370.svg')"
              />
            </v-col>
            <v-col
              cols="4"
              lg="10"
              md="10"
              sm="8"
              align-self="center"
              class="pl-0"
              style="position: relative;"
            >
              <span class="pl-5 text-333333 font-20 w-700"
                >ข้อมูลผู้ใช้บริการ</span
              >
            </v-col>
            <v-spacer></v-spacer>
            <v-btn icon @click="closePage" small color="#00A99D">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text class="px-12 pt-5 pb-12">
          <v-form ref="validate_save" class="px-3">
            <v-row class="bg-FAFAFA set-border ml-1 mb-3 py-2">
              <v-col cols="12" lg="6" md="6" sm="6" class="pr-0 text-overflow">
                <span class="pl-3 text-333333 font-16 w-700">ชื่อผู้ใช้บริการ :</span>
                <span class="pl-1 text-333333 font-16 w-500">{{ item.firstname }} {{ item.lastname }}</span>
              </v-col>
              <v-col
                cols="12"
                lg="6"
                md="6"
                sm="6"
                class="pr-0"
              >
                <span class="pl-3 text-333333 font-16 w-700">HN : </span>
                <span class="text-333333 font-16 w-500">{{ item.cardHN || '-' }}</span>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="6" class="pt-0">
                <span class="pl-3 text-333333 font-16 w-700"
                  >เลขบัตรประชาชน :
                </span>
                <span class="text-333333 font-16 w-500">{{ id(item.cardnum) || '-' }}</span>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="6" class="pt-0">
                <span class="pl-3 text-333333 font-16 w-700"
                  >เบอร์โทรศัพท์ :
                </span>
                <span class="text-333333 font-16 w-500">{{
                  mobile(item.mobile)
                }}</span>
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-row>
                  <v-col cols="auto">
                    <span class="pl-3 text-333333 font-16 w-700"
                      >ที่อยู่ :
                    </span>
                  </v-col>
                  <v-col cols="10" class="pl-0">
                    <span class="text-333333 font-16 w-500">{{ item.address || '-' }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="pt-0">
                <span class="pl-3 text-333333 font-16 w-700">จุดสังเกต : </span>
                <span class="text-333333 font-16 w-500">{{ item.landmark || "-" }}</span>
              </v-col>
              <v-col
                  cols="12"
                  lg="6"
                  md="6"
                  sm="6"
                  class="pt-0"
                >
                  <span class="pl-3 text-333333 font-16 w-700">ละติจูด : </span>
                  <span class="text-333333 font-16 w-500">{{ item.lat || '-' }}</span>
              </v-col>
              <v-col
                cols="12"
                lg="6"
                md="6"
                sm="6"
                class="pt-0"
              >
                <span class="pl-3 text-333333 font-16 w-700">ลองจิจูด : </span>
                <span class="text-333333 font-16 w-500">{{ item.lng || '-' }}</span>
              </v-col>
              <v-col
                cols="12"
                class="pt-0"
                v-if="latitude !== null && longitude !== null"
              >
              <span class="pl-3 text-333333 font-16 w-700">เเผนที่ : </span>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="ml-2"
                      v-bind="attrs"
                      v-on="on"
                      color="#00A99D"
                      size="24"
                      @click="openMap(latitude, longitude, 'view')"
                    >
                      mdi-map-marker-radius-outline
                    </v-icon>
                  </template>
                  <span>ดูเเผนที่</span>
                </v-tooltip>
              </v-col>
              <!-- <v-col cols="12" class="pt-0" v-if="view === true">
                <span class="pl-3 pr-0 text-333333 font-16 w-700">สิทธิการรักษา : </span>
                <span class="text-333333 font-16 w-500" v-if="item.medical_rights.medical_rights_name != 'อื่นๆ'">{{ item.medical_rights.medical_rights_name }}</span>
                <span class="text-333333 font-16 w-500" v-else-if="item.medical_rights.medical_rights_name == 'อื่นๆ'">{{ item.medical_rights.medical_rights_name_other }}</span>
                <span class="text-333333 font-16 w-500" v-else>-</span>
                <span class="text-333333 font-16 w-500">-</span>
              </v-col>
              <v-col cols="12" class="pt-0" v-else-if="view === true && medical_rights.length !== 0">
                <span class="pl-3 pr-0 text-333333 font-16 w-700">สิทธิการรักษา : </span>
                <span class="text-333333 font-16 w-500">-</span>
              </v-col>
              <v-col cols="12" v-if="medical_rights.length !== 0 && view === false">
                <v-row>
                  <v-col cols="12" class="pt-0" sm="6" md="4" lg="4">
                    <span class="pl-3 pr-0 text-333333 font-16 w-700">สิทธิการรักษา : </span>
                    <span v-if="view == true" class="text-333333 font-16 w-500"> - </span>
                  </v-col>
                </v-row>
                <v-row class="px-10">
                  <v-col cols="12" class="pt-0" sm="6" md="4" lg="4" v-for="(right, index) in medical_rights" :key="index">
                    <v-checkbox
                      hide-details="auto"
                      :rules="rule_rights_check"
                      class="pt-0 mt-0 pl-1"
                      color="#00A99D"
                      :value="right.medical_rights_name"
                      v-model="medical_rights_name"
                      style="padding-right: 102px;"
                      @click="checkRight(right)"
                      :readonly="medical_rights.length == 1"
                      :disabled="view === false ? false : true"
                    >
                      <template v-slot:label>
                        <span class="text-313B41 w-500 font-16">
                          {{right.medical_rights_name}}
                        </span>
                      </template>
                    </v-checkbox>
                    <v-row v-if="right.medical_rights_name == 'อื่นๆ' && medical_rights_name == 'อื่นๆ'">
                      <v-col cols="12" class="pl-10">
                        <div v-for="(other, index) in list_medical_rights_name_other" :key="index">
                          <v-checkbox
                            hide-details="auto"
                            :rules="rule_rights_check"
                            class="mt-1 pr-0 pl-2"
                            color="#00A99D"
                            :value="other.name"
                            v-model="medical_rights_name_other"
                            style="padding-right: 102px;"
                            :readonly="list_medical_rights_name_other.length == 1"
                            :disabled="view === false ? false : true"
                          >
                            <template v-slot:label>
                              <span class="text-313B41 w-500 font-16">
                                {{other.name}}
                              </span>
                            </template>
                          </v-checkbox>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col> -->
              <div v-if=" item.status == 1 && 'order_type' in item && item.order_type == 'flash' && view === false" style="display: contents;">
                <v-col cols="12" class="pr-0 pt-0 text-overflow">
                  <span class="pl-3 text-333333 font-16 w-700">บริษัทขนส่ง : Flash Express</span>
                </v-col>
                <v-col
                  cols="12"
                  lg="4"
                  md="4"
                  sm="4"
                  class="pl-9"
                  align-self="start"
                >
                  <v-row>
                    <v-col cols="12" lg="auto" md="auto" sm="auto" align-self="start" class="pr-0 pt-4">
                      <span class="pl-6 pt-2 text-333333 font-16 w-700">น้ำหนัก :</span>
                    </v-col>
                    <v-col cols="12" lg="auto" md="auto" sm="auto" class="pl-2 pr-0">
                      <v-text-field
                        class="text-333333 font-16 w-500 pr-2"
                        v-model="weight"
                        solo
                        dense
                        hide-details="auto"
                        require
                        :rules="rule_weight"
                        style="max-width: 100px"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="auto" md="auto" sm="auto" align-self="start" class="pl-0 pt-4">
                      <span class="text-333333 font-16 w-700">กรัม</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  lg="8"
                  md="8"
                  sm="8"
                  align-self="start"
                  class="pt-0"
                >
                  <v-row>
                    <v-col
                      class="pl-10 pt-7 pr-2"
                      cols="12"
                      lg="auto"
                      md="auto"
                      sm="auto"
                      align-self="start"
                    >
                      <span class="text-333333 font-16 w-700"
                        >ขนาดพัสดุ :</span
                      >
                    </v-col>
                    <v-col class="pt-0 pl-3" cols="12" lg="9" md="9" sm="9" align-self="start">
                      <v-row class="py-0 mt-0">
                        <v-col
                          class="pt-0 pl-0"
                          cols="12"
                          lg="3"
                          md="3"
                          sm="3"
                          ><span>เบอร์กล่อง</span>
                          <v-select
                            v-model="select_box"
                            :items="box_size"
                            item-text="title"
                            item-value="size"
                            hide-details="auto"
                            solo
                            dense
                            color="#00A99D"
                            item-color="#00A99D"
                            :menu-props="{ bottom: true, offsetY: true }"
                            :rules="rule_select_box"
                            return-object
                          >
                            <template slot="no-data">
                              <span class="pl-2"
                                >ไม่มีข้อมูลเบอร์กล่อง</span
                              >
                            </template>
                          </v-select>
                        </v-col>
                        <v-col
                          :class="select_box != '' && parseInt(select_box.size.price) !== 0 ? 'pt-0 pb-2':''"
                          cols="12"
                          lg="4"
                          md="4"
                          sm="4"
                          ><span>กว้าง x ยาว x สูง</span><br />
                          <span
                            style="line-height: 2.3;"
                            v-if="select_box != ''"
                            class="text-333333 font-16 w-500"
                            >{{ select_box.size.width }} x
                            {{ select_box.size.length }} x
                            {{ select_box.size.height }} ซม.</span
                          >
                        </v-col>
                        <v-col
                          class="pt-0 pb-2"
                          cols="12"
                          lg="3"
                          md="3"
                          sm="3"
                          ><span>ราคา</span><br />
                          <span
                            style="line-height: 2.3;"
                            v-if="select_box != '' && view == false"
                            class="text-333333 font-16 w-500"
                            >{{ parseInt(select_box.size.price) || 0 }} บาท</span
                          >
                          </v-col
                        >
                        <v-col
                          class="pt-3 pl-0"
                          cols="12"
                          lg="auto"
                          md="1"
                          sm="1"
                          align-self="start"
                        >
                          <v-menu offset-y bottom left max-height="200px">
                            <template
                              v-slot:activator="{ on: menu, attrs }"
                            >
                              <v-tooltip bottom>
                                <template
                                  v-slot:activator="{ on: tooltip }"
                                >
                                  <img
                                    v-bind="attrs"
                                    v-on="{ ...tooltip, ...menu }"
                                    :src="
                                      require('@/assets/icon/Telepharma/box 1.svg')
                                    "
                                  />
                                </template>
                                <span>ดูขนาดพัสดุ</span>
                              </v-tooltip>
                            </template>
                            <v-list>
                              <v-list-item
                                v-for="(item, index) in box_size"
                                :key="index"
                              >
                                <v-list-item-title>
                                  <span class="text-333333 font-16 w-700"
                                    >เบอร์กล่อง : {{ item.title }}</span
                                  ><br />
                                  <span class="text-333333 font-16 w-500"
                                    >ขนาด : {{ item.size.width }} x
                                    {{ item.size.length }} x
                                    {{ item.size.height }} ซม.</span
                                  ><br />
                                  <span class="text-333333 font-16 w-500"
                                    >ราคา : {{ item.size.price }} บาท</span
                                  ><br /><br />
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </div>
              <div v-else-if="'order_type' in item && item.order_type == 'flash' && view === true" style="display: contents;">
                <v-col cols="12" class="pr-0 pt-0 text-overflow">
                  <span class="pl-3 pt-0 text-333333 font-16 w-700">บริษัทขนส่ง : Flash Express</span>
                </v-col>
                <v-col 
                  cols="12"  
                  lg="4"
                  md="4"
                  sm="4"
                  class="pl-9"
                  align-self="start"
                >
                  <v-row>
                     <v-col
                      cols="12"
                      lg="auto"
                      md="auto"
                      sm="auto"
                      align-self="start"
                      class="pr-0 pt-4"
                    >
                      <span class="pr-2 pt-2 text-333333 font-16 w-700"
                        >น้ำหนัก :</span
                      >
                    </v-col>
                    <v-col
                      cols="12"
                      lg="auto"
                      md="auto"
                      sm="auto"
                      class="pl-2 pr-0"
                    >
                      <v-text-field
                        class="text-333333 font-16 w-500 pr-2"
                        v-model="weight"
                        solo
                        dense
                        hide-details="auto"
                        readonly
                        style="max-width: 100px"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="auto" md="auto" sm="auto" align-self="start" class="pl-0 pt-4">
                      <span class="pt-2 text-333333 font-16 w-700">กรัม</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12"  
                  lg="8"
                  md="8"
                  sm="8"
                  align-self="start"
                  class="pt-0"
                >
                  <v-row>
                    <v-col cols="12" style="display: flex">
                      <v-row>
                        <v-col
                        class="pl-10 pt-7 pr-2"
                          cols="12"
                          lg="auto"
                          md="auto"
                          sm="auto"
                          align-self="start"
                        >
                          <span class="pl-3 text-333333 font-16 w-700"
                            >ขนาดพัสดุ :</span
                          >
                        </v-col>
                        <v-col class="pt-0 pl-3" cols="12" lg="8" md="8" sm="8" align-self="start">
                          <v-row class="py-0 mt-0">
                            <v-col
                              class="pt-0 pl-0"
                              cols="12"
                              lg="3"
                              md="3"
                              sm="3"
                            ><span>เบอร์กล่อง</span>
                              <v-text-field
                                v-model="select_box.title"
                                hide-details="auto"
                                solo
                                dense
                                color="#00A99D"
                                item-color="#00A99D"
                                readonly
                              ></v-text-field>
                            </v-col>
                            <v-col
                              class="pt-0 pb-2"
                              cols="12"
                              lg="auto"
                              md="auto"
                              sm="auto"
                              ><span>กว้าง x ยาว x สูง</span><br />
                              <span
                                style="line-height: 2.3;"
                                v-if="select_box != ''"
                                class="text-333333 font-16 w-500"
                                >{{ select_box.size.width }} x
                                {{ select_box.size.length }} x
                                {{ select_box.size.height }} ซม.</span
                              >
                            </v-col>
                            <v-col
                              class="pt-0 pb-2"
                              cols="12"
                              lg="3"
                              md="3"
                              sm="3"
                              ><span>ราคา</span><br />
                              <span
                                style="line-height: 2.3;"
                                v-if="select_box != '' && view == true"
                                class="text-333333 font-16 w-500"
                                >{{ parseInt(select_box.size.price) || 0 }} บาท</span
                              >
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </div>
            </v-row>

            <v-row class="bg-FAFAFA set-border ml-1 mb-3 pt-2">
              <v-col cols="12" class="pr-0 text-overflow">
                <span class="pl-3 text-333333 font-16 w-700"
                  >รายละเอียดเพิ่มเติม :
                </span>
              </v-col>
              <v-col cols="12" class="px-5 text-overflow">
                <v-textarea
                  outlined
                  rows="4"
                  row-height="15"
                  background-color="#ffffff"
                  color="#00A99D"
                  v-model="note"
                  :disabled="view"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row
              class="bg-FAFAFA set-border ml-1 mb-3 pt-2"
              v-if="item.status == 4"
            >
              <v-col cols="12" class="pr-0 text-overflow">
                <span class="pl-3 text-FF6270 font-16 w-700"
                  >หมายเหตุการยกเลิก :
                </span>
              </v-col>
              <v-col cols="12" class="px-5 text-overflow">
                <v-textarea
                  outlined
                  rows="4"
                  row-height="15"
                  background-color="#ffffff"
                  color="#00A99D"
                  v-model="item.note_cancel"
                  :disabled="view"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row v-if="view === false">
              <v-col align="right" v-if="'order_type' in item">
                 <v-btn
                  v-if="item.order_type === 'flash'"
                  style="border-radius: 20px 5px;"
                  color="#00A99D"
                  dark
                  @click="saveform(select_box)"
                  :loading="btn_loading"
                >
                  ยืนยันข้อมูลการจัดส่ง
                </v-btn>
                <v-btn
                  v-else
                  style="border-radius: 20px 5px;"
                  color="#00A99D"
                  dark
                  @click="confirm()"
                  :loading="btn_loading"
                >
                  ยืนยันข้อมูลการจัดส่ง
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <Sweetdialog ref="sweetDialog" @submit="submit" />
    <MapDialog ref="mapDialog" />

  </div>
</template>

<script>
import Sweetdialog from "../Sweetdialog.vue";
import MapDialog from "../MapDialog.vue";
import set_package from "../box_size.json";
import { mapGetters } from "vuex";

export default {
  components: {
    Sweetdialog,
    MapDialog,
  },
  data() {
    return {
      dialog: false,
      item: {},
      btn_loading: false,
      latitude: null,
      longitude: null,
      view: true,
      medical_rights: [],
      medical_rights_name: '',
      medical_rights_name_other: '',
      list_medical_rights_name_other:[
        {
          name: 'ประกันสังคม'
        },
        {
          name: 'ข้าราชการ'
        }
      ],
      choose: {},
      select_box: {
        title: "",
        size: {
          width: 0,
          length: 0,
          height: 0,
          price: 0,
        },
      },
      box_size: [],
      set_package,
      note: "",
      weight: 0,
      width: 0,
      length: 0,
      height: 0,
      rule_select_box: [(v) => v.size.width !== 0 || "กรุณาเลือกขนาดพัสดุ"],
      rule_weight: [(v) => !!v || "กรุณากรอกน้ำหนักพัสดุ"],
      rule_width: [(v) => !!v || "กรุณากรอกความกว้างพัสดุ"],
      rule_length: [(v) => !!v || "กรุณากรอกความยาวพัสดุ"],
      rule_height: [(v) => !!v || "กรุณากรอกความสูงพัสดุ"],
      rule_rights_check: [(v) => !!v || "กรุณาเลือกสิทธิการรักษา"],
      rule_medical_rights_name_other: [(v) => !!v || "กรุณากรอกสิทธิการรักษา"],
    }
  },
  computed: {
    ...mapGetters({
      organization_vuex: "organizationGetter" || [],
    }),
  },
  methods: {
    id(id) {
      if (id == undefined) return "-";
      if (id.length == 13) {
        return (
          id.substring(0, 1) +
          "-" +
          id.substring(1, 5) +
          "-" +
          id.substring(5, 10) +
          "-" +
          id.substring(10, 12) +
          "-" +
          id.substring(12, 13)
        );
      } else return id;
    },
    async openDialog(item, view) {

      // console.log('set_package', this.set_package);
      var organization = this.organization_vuex

      this.box_size = organization.pharma_setup.box_size

      this.dialog = true
      this.latitude = parseFloat(item.lat) || null;
      this.longitude = parseFloat(item.lng) || null;
      this.view = view;
      this.item = item

      // console.log(organization);

      // this.medical_rights_name = 'ไม่ใช้สิทธิ'
      // this.checkRight(this.medical_rights[0])

      if ('Parcel_Option_Detail' in item && item.Parcel_Option_Detail !== null && item.Parcel_Option_Detail !== undefined) {
        this.weight = item.Parcel_Option_Detail.weight 
        this.width = item.Parcel_Option_Detail.width
        this.length = item.Parcel_Option_Detail.length
        this.height = item.Parcel_Option_Detail.height

        this.select_box.size.width = item.Parcel_Option_Detail.width;
        this.select_box.size.length = item.Parcel_Option_Detail.length;
        this.select_box.size.height = item.Parcel_Option_Detail.height;
        this.select_box.size.price = parseInt(item.Parcel_Option_Detail.box_price)
        this.select_box.title = item.Parcel_Option_Detail.box_size
      } else {
        this.weight = 1000
        this.width = 0
        this.length = 0
        this.height = 0
        this.select_box = {
          title: "",
          size: {
            width: 0,
            length: 0,
            height: 0,
            price: 0,
          }
        }
      }
    },
    closePage() {
      this.$refs.validate_save.resetValidation();
      this.dialog = false;
      this.medical_rights = []
      this.medical_rights_name = ''
      this.medical_rights_name_other = ''
      this.box_size = []
      this.select_box = {
        title: "",
        size: {
          width: 0,
          length: 0,
          height: 0,
          price: 0,
        },
      }
    },
    mobile(mobile) {
      if (mobile == undefined) return "-";
      if (mobile.length == 10) {
        return (
          mobile.substring(0, 3) +
          "-" +
          mobile.substring(3, 6) +
          "-" +
          mobile.substring(6, 10)
        );
      } else return mobile;
    },
    openMap(lat, lng, type) {
      this.$refs.mapDialog.openDialog(lat, lng, type);
    },
    checkRight(rights) {
      // console.log(rights);
      this.choose = rights
    },
    confirm() {
      const data = {
        title:
          "<span style='color: black;font-size: 24px;font-family: Sarabun;font-weight: 500;'><b>ยืนยันข้อมูลที่อยู่จัดส่งหรือไม่</b></span>",
        html:
          "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'></span>",
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText:
          "<span style='color: #F5222D;font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
        cancelButtonColor: "#FFFFFF",
        showConfirmButton: true,
        confirmButtonText:
          "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
        confirmButtonColor: "#00A99D",
        allowOutsideClick: false,
        returnEmit: "confirm",
      };
      this.$refs.sweetDialog.open(data);
    },
    async submit(data) {
      try {
        this.btn_loading = true;
        console.log("submit", data);

        var data_order = {
          note_order: this.note,
          register_id: this.item.register_id,
          biz_id: sessionStorage.biz_id,
          patient_id: this.item.one_id,
          staff_id: sessionStorage.account_id,
          // use_medical_rights: this.medical_rights_name == 'ไม่ใช้สิทธิ' || this.clinic_data.length == 0 ? false : true,
          use_medical_rights: false,
          // medical_rights_name: this.choose.medical_rights_name || '',
          medical_rights_name: 'ไม่ใช้สิทธิ',
          // medical_rights_name_other: this.medical_rights_name_other  || ''
        }
        
        this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/transport/add_transport`, data_order).then(async (res) => {
          if (res.data.code == 200 && res.data.result == "success") {
              this.btn_loading = false;
              const data = {
                title:
                  "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลสำเร็จ</span>",
                icon: "success",
                showConfirmButton: false,
                confirmButtonText: "ปิด",
                confirmButtonColor: "#3085d6",
                timer: 1500,
              };
              this.$refs.sweetDialog.open(data);
              this.closePage();
              this.$emit("close");
            } else {
              const data = {
                title:
                  "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลไม่สำเร็จ</span>",
                icon: "error",
                showConfirmButton: false,
                confirmButtonText: "ปิด",
                confirmButtonColor: "#3085d6",
              };
              this.btn_loading = false;
              this.$refs.sweetDialog.open(data);
            }
        })
      } catch (e) {
        console.log("error", e);
        const data = {
          title:
            "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลไม่สำเร็จ</span>",
          icon: "error",
          showConfirmButton: false,
          confirmButtonText: "ปิด",
          confirmButtonColor: "#3085d6",
        };
        this.btn_loading = false;
        this.$refs.sweetDialog.open(data);
      }
    },
    async saveform(select_box) {
      if (!this.$refs.validate_save.validate()) {
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>กรุณากรอกข้อมูลให้ครบถ้วน</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      } else {
        try {
          this.width = select_box.size.width;
          this.length = select_box.size.length;
          this.height = select_box.size.height;
          this.price = parseInt(select_box.size.price)

          var data = {
            order_type: this.item.order_type,
            biz_id: sessionStorage.biz_id,
            patient_id: this.item.one_id,
            register_id: this.item.register_id,
            box_size: this.select_box.title,
            weight: this.weight,
            width: this.width,
            length: this.length,
            height: this.height,
            box_price: this.price,
            insured: "0"
          }
          // console.log('data_box', data);

          this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/transport/update_flash_data`, data).then(async (res) => {
            if (res.data.code == 200 && res.data.result == "success") {
              this.confirm()
            } else {
              const data = {
                title:
                  "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เพิ่มข้อมูลพัสดุไม่สำเร็จ</span>",
                icon: "error",
                showConfirmButton: false,
                confirmButtonText: "ปิด",
                confirmButtonColor: "#3085d6",
              };
              this.$refs.sweetDialog.open(data);
            }
          })

        } catch (error) {
          console.log("error", error);
          const data = {
            title:
              "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เพิ่มข้อมูลพัสดุไม่สำเร็จ</span>",
            icon: "error",
            showConfirmButton: false,
            confirmButtonText: "ปิด",
            confirmButtonColor: "#3085d6",
          };
          this.$refs.sweetDialog.open(data);
          this.closePage();
        }
      }
    },
  }
}
</script>

<style scoped>
.set-border {
  border: 1px solid #ebebeb;
  border-radius: 10px;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .v-messages__message {
  line-height: 15px !important;
}

::v-deep .theme--light.v-input--is-disabled textarea {
  color: #333333 !important;
}

.text-overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>